/* eslint-disable camelcase */
export const GET = 'GET'
export const POST = 'POST'
export const DELETE = 'DELETE'

export const HTTP_STATUS_CODE_INTERNAL_ERROR = 500
export const HTTP_STATUS_CODE_OK = 200

// Epoch-millisecond durations. Every server-side window (rate limits, TTLs, staleness) counts from
// `Date.now()`, which is UTC-based epoch time everywhere — no local-timezone arithmetic.
export const ONE_SECOND = 1000
export const ONE_MINUTE_MS = 60 * ONE_SECOND // 60 s
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS // 60 min
export const ONE_DAY_MS = 24 * ONE_HOUR_MS // 24 h

export const sv = 'sv'
export const en = 'en'
export const LANGUAGES = [sv, en]

export const YYYYMMDDHHmmss = 'YYYY-MM-DDTHH:mm:ss'
export const YYYY_MM_DD = 'YYYY-MM-DD'

export const EUROPE_WEST_3 = 'europe-west3'
export const REGION = EUROPE_WEST_3

export const USER_ID = 'userId'

export const NO_OF_LETTERS_IN_SIGN_IN_CODE = 6

export const INFO_EMAIL_ADDRESS = 'info@intraction.com'

/** The only domain that may hold platform-operator rights in production. */
export const SUPER_ADMIN_EMAIL_DOMAIN = '@intraction.com'

/** AI agent accounts for the agentic testing layer. Dev projects only. */
export const AI_AGENT_EMAIL_DOMAIN = '@intraction-agents.dev'

export const YOUTUBE_URL = 'https://www.youtube.com/@intraction'

export const NOT_AUTHENTUCATED_ERROR_MESSAGE = 'Not authenticated'

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB8kFI2XkRifXqhdZwCdpluL18xjVKOjEE',
  authDomain: 'intraction-web.web.app',
  projectId: 'intraction-f177a',
  storageBucket: 'intraction-f177a.appspot.com',
  messagingSenderId: '10684929325',
  appId: '1:10684929325:web:e2a47886e4b8eb83a6efa4',
  measurementId: 'G-CVC20N6BPX'
}

// TODO change to production URL before launch
export const APP_URL = 'https://app.intraction.com/'
export const APP_URL_DEV = 'https://intraction-dev.web.app'

export const PUBLIC_SITE_URL = 'https://intraction.com'
// Not dev.intraction.com: that domain only forwards here and drops the path
export const PUBLIC_SITE_URL_DEV = 'https://intraction-website-dev.web.app'

export const MAX_USERS_IN_TEAM = 4

export const MIN_SLOT_TIME_INTERVAL_MINUTES = 14
